import gql from "graphql-tag";
import { VeriflytAccountFragment } from "Queries/Veriflyt";
import {OrganizationFragment} from "../../../Queries/Organization";

export const GET_VERIFLYT_ACCOUNT = gql`
    query VeriflytOrganization_GetVeriflytAccount($veriflytID: ID!) {
        GetVeriflytAccount(veriflytID: $veriflytID) {
            ...VeriflytAccountFragment
        }
    }
    ${VeriflytAccountFragment}
`

export const GET_ORGANIZATION = gql`
    query VeriflytOrganization_GetOrganization($orgID: ID!) {
        getOrganization(_id: $orgID) {
            ...OrganizationFragment
        }
    }
    ${OrganizationFragment}
`